<div
    *ngIf="!dismissed && (banner$ | async) as banner"
    class="notification-banner-wrapper px-4 md:px-6 py-3 print:hidden"
>
    <div
        class="notification-banner relative flex items-center justify-center gap-2.5 w-full rounded-xl border py-2.5 px-12 shadow-sm"
        [ngClass]="levelClass(banner.level)"
        role="status"
    >
        <mat-icon class="notification-banner__icon shrink-0">{{ levelIcon(banner.level) }}</mat-icon>

        <div class="notification-banner__content min-w-0 text-center leading-snug">
            <span *ngIf="banner.title" class="notification-banner__title font-semibold mr-1.5">{{ banner.title }}</span>
            <span class="notification-banner__message text-sm">{{ banner.message }}</span>
            <a
                *ngIf="banner.link_url"
                [href]="banner.link_url"
                target="_blank"
                rel="noopener noreferrer"
                class="notification-banner__link ml-1.5 whitespace-nowrap"
                >{{ banner.link_label || banner.link_url }}</a
            >
        </div>

        <button
            *ngIf="banner.is_dismissible"
            type="button"
            class="notification-banner__close absolute right-2.5 top-1/2 -translate-y-1/2 flex items-center justify-center w-8 h-8 rounded-lg"
            [attr.aria-label]="'Close' | transloco"
            (click)="onClose()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
